module.exports = __webpack_public_path__ + "static/media/reporte2015-16.c8760408.png";